import { Grid } from '@mui/material';
import { NetworkMap, NetworkTrafficTable, NetworkOverviewTable, transformNetworkOverviewData } from '@kw/quokka-ui';

type NetworkInfoTabProps = {
  geolocationsData?: unknown[];
  trafficData?: unknown[];
  sslPinningData?: unknown[];
  staticUrisData?: unknown[];
  highRiskCountries: string[];
  downloadPcapCallback: () => void | Promise<void>;
};

export const NetworkInfoTab = ({
  geolocationsData,
  trafficData,
  sslPinningData,
  staticUrisData,
  highRiskCountries,
  downloadPcapCallback,
}: NetworkInfoTabProps) => (
  <Grid container direction="column" spacing={5}>
    <Grid item xs={12}>
      <NetworkMap
        geolocations={geolocationsData}
        mapTilerApiKey={process.env.REACT_APP_MAPTILER_API_KEY}
        highRiskCountryCodes={highRiskCountries}
      />
    </Grid>
    <Grid item xs={12}>
      <NetworkOverviewTable
        traffic={transformNetworkOverviewData({ sslPinning: sslPinningData, staticUrls: staticUrisData, geolocations: geolocationsData })}
        highRiskCountries={highRiskCountries}
      />
    </Grid>
    <Grid item xs={12}>
      <NetworkTrafficTable traffic={trafficData} downloadPcapCallback={downloadPcapCallback} />
    </Grid>
  </Grid>
);
